<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Peter Legaard Nielsen, born in 1960, is a Danish author, who made his debut with a poetry collection, <em>The Bloody Temple of the Heart</em>, in 1985 and had his breakthrough with the novel, <em>While the Sun Slowly Burns Up</em>, in 1987. <em>Darkness Without Limits</em> is his second novel. He has published 9 novels and 2 poetry collections and edited a large number of anthologies.</p><br/>
<p style="text-indent:0em">He was chairman of the Danish Fiction Writers Association from 1997–2001 and from 2002–2007. In 1992, he was awarded a 3-year grant from the state’s Art Fund. He was a literary reviewer at a newspaper from 1987 to 1992.</p><br/>
<p style="text-indent:0em">Peter is also an Authorized Advanced Rolfer™ and an Authorized Level 3 IFS Practitioner.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?28b2cf7e